<template>
  <div>
    <aside>
      <div class="top">
        <div class="logo">
          <!-- <img src="../assets/logo-filled.png" alt="" /> -->
          <h2>MET<span class="danger">ALL</span></h2>
        </div>
        <div class="close" id="close-btn" @click="closeMenu">
          <span class="material-icons-sharp"> close </span>
        </div>
      </div>

      <div class="profile">
        <div class="profile-photo">
          <img src="@/assets/avatar.png" alt="Profile photo" />
        </div>
        <div class="info">
          <p>
            Здравствуйте, <b>{{ USER.first_name | TitleCase }}</b>
          </p>
          <small class="text-muted">{{
            USER.ouser.role[0].name | TitleCase
          }}</small>
        </div>
      </div>

      <div class="sidebar">
        <router-link :to="{ name: 'dashboard' }">
          <span class="material-icons-sharp">dashboard</span>
          <h3>Главная</h3>
        </router-link>

        <router-link
          :to="{ name: 'create-report' }"
          v-if="
            this.$store.getters.isActiveAccount &&
              accessLevel(USER.ouser.role, 1)
          "
        >
          <span class="material-icons-sharp">note_add</span>
          <h3>Создание отчета</h3>
        </router-link>

        <router-link
          :to="{ name: 'report-statuses' }"
          v-if="
            this.$store.getters.isActiveAccount &&
              accessLevel(USER.ouser.role, 3)
          "
        >
          <span class="material-icons-sharp">assignment</span>
          <h3>Статусы отчетов</h3>
        </router-link>

        <router-link
          :to="{ name: 'my-reports-updated' }"
          v-if="this.$store.getters.isActiveAccount"
        >
          <span class="material-icons-sharp">assignment</span>
          <h3>Мои отчеты</h3>
        </router-link>

        <router-link
          :to="{ name: 'reports' }"
          v-if="this.$store.getters.isActiveAccount"
        >
          <span class="material-icons-sharp">description</span>
          <h3>Другие отчеты</h3>
        </router-link>

        <router-link
          :to="{ name: 'check-tmz-step' }"
          v-if="
            this.$store.getters.isActiveAccount &&
              accessLevel(USER.ouser.role, 1)
          "
        >
          <span class="material-icons-sharp">post_add</span>
          <h3>ТМЗ +</h3>
        </router-link>

        <router-link
          :to="{ name: 'tmz-not-report' }"
          v-if="this.$store.getters.isActiveAccount"
        >
          <span class="material-icons-sharp">text_snippet</span>
          <h3>Отчеты ТМЗ</h3>
        </router-link>

        <router-link
          :to="{ name: 'tmz-my-report' }"
          v-if="this.$store.getters.isActiveAccount"
        >
          <span class="material-icons-sharp">source</span>
          <h3>Мои Отчеты ТМЗ</h3>
        </router-link>

        <router-link :to="{ name: 'messenger' }">
          <span class="material-icons-sharp">dashboard</span>
          <h3>Чат</h3>
          <span class="message-count">26</span>
        </router-link>

        <router-link
          :to="{ name: 'learning' }"
          v-if="this.$store.getters.isActiveAccount"
        >
          <span class="material-icons-sharp">school</span>
          <h3>Обучение</h3>
        </router-link>

        

        <router-link :to="{ name: 'logout' }">
          <span class="material-icons-sharp">logout</span>
          <h3>Выйти</h3>
        </router-link>

        <div class="theme-toggler">
          <input
            @click="changeTheme"
            type="checkbox"
            class="checkbox"
            id="chk"
          />
          <label class="label" for="chk">
            <i class="fas fa-moon"></i>
            <i class="fas fa-sun"></i>
            <div class="ball"></div>
          </label>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    closeMenu: () => {
      const menu = document.querySelector("aside");
      menu.style.display = "none";
    },
    changeTheme: () => {
      document.body.classList.toggle("dark-theme-variables");
    },
    accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(JSON.parse(JSON.stringify(this.USER.ouser.role)));
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters(["isActiveAccount", "USER"]),
  },
};
</script>

<style lang="scss" scoped>
aside {
  height: 100vh;
}

aside .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.4rem;
}

.profile {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

aside .logo {
  display: flex;
  gap: 0.8rem;
}

aside .logo img {
  width: 2rem;
  height: 2rem;
}

aside .close {
  display: none;
}

aside .sidebar {
  display: flex;
  flex-direction: column;
  height: 86vh;
  position: relative;
  top: 3rem;
}

aside h3 {
  font-weight: 500;
}

aside .sidebar a {
  display: flex;
  color: var(--color-info-dark);
  margin-left: 2rem;
  gap: 1rem;
  align-items: center;
  position: relative;
  height: 3.7rem;
  transition: var(--transition-standard);
}

aside .sidebar a span {
  font-size: 1.6rem;
  transition: var(--transition-standard);
}

aside .sidebar a:last-child {
  margin-top: auto;
}

.sidebar a.router-link-exact-active {
  background: var(--color-light);
  color: var(--color-primary);
  margin-left: 0;
}

.sidebar a.router-link-exact-active::before {
  content: "";
  width: 6px;
  height: 100%;
  background: var(--color-primary);
}

aside .sidebar a.active span {
  color: var(--color-primary);
  margin-left: calc(1rem - 6px);
}

aside .sidebar a:hover {
  color: var(--color-primary);
}

aside .sidebar a:hover span {
  margin-left: 1rem;
}

aside .sidebar .message-count {
  background: var(--color-danger);
  color: var(--color-white);
  columns: var(--color-white);
  padding: 2px 10px;
  font-size: 11px;
  border-radius: var(--border-radius-1);
}

.theme-toggler {
  display: block;
  margin: 2rem auto 0;
}

/* MEDIA */

@media screen and (max-width: 1200px) {
  aside .logo h2 {
    display: none;
  }

  aside .sidebar h3 {
    display: none;
  }

  aside .sidebar a {
    width: 5.6rem;
  }

  aside .sidebar a:last-child {
    margin-top: 1rem;
  }

  .profile {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  aside {
    height: 100vh;
    position: fixed;
    left: -100%;
    background: var(--color-white);
    width: 18rem;
    z-index: 3;
    box-shadow: 1rem 3rem 4rem var(--color-light);
    padding-right: var(--card-padding);
    display: none;
    animation: showMenu 400ms ease forwards;
    transition: var(--transition-standard);
  }

  @keyframes showMenu {
    to {
      left: 0;
    }
  }

  aside .logo {
    margin-left: 1rem;
  }

  aside .logo h2 {
    display: inline;
  }

  aside .sidebar h3 {
    display: inline;
  }

  aside .sidebar a {
    width: 100%;
    height: 3.4rem;
  }

  aside .sidebar a:last-child {
    margin-top: auto;
  }

  aside .close {
    display: inline-block;
    cursor: pointer;
  }
}
</style>
